import React from "react";
import FiberImage
  from "../../common/results/views/fiber/types/components/fiberimage";
import Grid from "material-ui/Grid/index";
import {withStyles} from "material-ui/styles/index";
import styles from "./BatteryStatementStyles";

class BatteryStatementDe extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {classes} = this.props;

    return <div className={classes.batteryAgreement}>
      <p className={classes.warning}>
        Wichtige Informationen zu Produkten welche
        Lithium-/Lithium-Ionen-Batterien enthalten – Es ist verboten
        beschädigte/defekte Akkus zu versenden.
      </p>
      <p>
        <b>Überprüfen Sie den Akku!</b> Der Akku muss vor dem Versand entfernt
        werden, wenn Sie wissen, dass der Akku
        heruntergefallen oder beschädigt ist. Oder wenn Sie eines der folgenden
        Anzeichen bemerken:
      </p>
      <ul>
        <li>Aufgequellt/Aufgebläht</li>
        <li>Farbwechsel</li>
        <li>Undicht</li>
        <li>Ungewöhnlicher Geruch</li>
        <li>Überhitzung</li>
        <li>Unregelmäßige Geräteleistung</li>
      </ul>
      <p>
        Stellen Sie sicher, dass beschädigte Batterien und Akkus gemäß den
        örtlichen Vorschriften entsorgt werden.</p>
      <p>Als Versender des Produktes, einschließlich, aber nicht beschränkt auf
        die Rücksendung zur Reparatur, Wartung
        oder Kalibrierung, sind Sie dafür verantwortlich, sicherzustellen, dass
        dies sicher und gesetzeskonform erfolgt.
        Wenn Sie Ihr Gerät mit Batterien zurücksenden, kreuzen Sie bitte an,
        dass Sie die oben genannten
        Informationen gelesen haben, und verpacken Sie das Gerät ordnungsgemäß.
      </p>
      <p><b>Verpackung für den Versand:</b></p>
      <ul>
        <li>
          Der Akku in Ihrem Gerät wurde gemäß der UN38.3-Spezifikation getestet
          Er beträgt &lt; 20 Wh pro Zelle / 100 Wh pro Batterie
          Das Batteriegewicht kann je nach Produkt zwischen 200 und 800 g liegen
          Wenn es in Geräten enthalten ist, muss folgendes beachtet werden:
          <ul>
            <li>UN3481</li>
            <li>Richtige Versandbezeichung - Lithium-Ionen-Batterien enthalten
              im Gerät
            </li>
            <li>Versand gemäß IATA DGR-Verpackungsanweisung 967 Abschnitt II
            </li>
          </ul>
        </li>
        <li>Lassen Sie den Akku im Gerät</li>
        <li>Versichern Sie sich, dass das Gerät ausgeschaltet ist und nicht
          versehentlich, während dem Versand
          eingeschaltet werden kann.
        </li>
        <li>Für den Transport sollte der Akku eine Ladung von 30% nicht
          überschreiten
          <br/>
          Oder<br/>
          Von 1. Januar 2026 sollte der Akku eine Ladung von 30% der Kapazität
          oder eine angegebene
          Batteriekapazität von 25%nicht überschreiten.
        </li>
        <li>5KG Batteriegewicht pro Paket nicht überschreiten.
        </li>
        <li>Stellen Sie sicher, dass sich Ihr Gerät in einer stabilen
          Außenverpackung befindet, die einen Sturz aus 1,2 m
          Höhe unbeschadet übersteht
        </li>
        <li>Die Vorderseite Ihres Pakets sollte ansonsten frei von Markierungen
          sein und die folgenden Informationen
          sollten auf einer Seite Ihres Paketes befestigt sein. Die Etiketten
          müssen angemessen vor Beschädigung und
          äußeren Einflüssen geschützt sein:
          <ul>
            <li>Sender Name und Adresse</li>
            <li>Empfänger Name und Adresse</li>
            <li>UN3481 Batterie Etikett (Etikettengröße 100mm x 100mm/ UN3481
              Text sollte mindestens 12mm groß
              sein)
            </li>
          </ul>
        </li>
        <li>Versichern Sie sich, dass das Gerät in der Verpackung gesichert ist
          und sich nicht bewegt.
        </li>
        <li>Versichern Sie sich, dass der Spediteur die Lieferung mit
          “Lithium-Ionen-Batterien gemäß Abschnitt II von PI
          967” kennzeichnet. (Sollte TREND Networks den Spediteur Buchen, ist es
          die Verantwortung von TREND
          Networks)
        </li>
      </ul>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} align="center">
        <FiberImage
          alt=""
          src={'/images/battery-agreement.png'}
        />
      </Grid>
      <p>Geräte welche Lithium-Ionen-Akkus enthalten:</p>
      <p>SignalTEK QT, 10G CT/NT/FT/PRO, LanTEK II/III/IV/S/L, SecuriTEST IP,
        FiberMASTER QUAD/Multi mode/Single mode/Pon OTDR, FiberMASTER Fusion
        Splicer S40 & S60</p>
      <p className={classes.warning}>
        Bitte stellen Sie sicher, dass beim Rückersand Ihres Geräts an TREND
        Networks KEINE verbotenen
        Gegenstände im Paket sind. Dazu gehöre unter anderem: Alkohol,
        Klingenwerkzeuge (Scheren, Messer,
        Cleaver, uws.), Aerosole, ätzende Stoffe, brennbare Flüssigkeiten, usw.
      </p>
    </div>;
  }
}

export default withStyles(styles)(BatteryStatementDe);
